import React from 'react';
import { Avatar, Icon, Tooltip, Form } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from './messages';
import './SettingsMenu.scss';
import LogOutButton from '../Auth/LogOutButton';
import { getConfiguration } from '../Collaborators/Collaborators';
import { JobCreditIcon } from '../../Icons/AryaIcons';
import LinkButton from '../Common/LinkButton/LinkButton';
import BudgetIndicator from '../../Containers/BudgetUsage/BudgetIndicator';
import { isCalendarHomePage } from '../../Utils/CalendarUtils';

const SettingsMenu = ({
  email,
  firstName,
  lastName,
  role,
  signOut,
  history,
  hidePopover,
  toggleClientAddDrawer,
  featureToggleList,
  visible,
  fetchOrgActivatedJobsCount,
  userConfig,
  fetchOrgOpenedJobsCount,
  intl,
  currentUserBudget,
  postBudgetCappingRequest,
  postCreditsRequestApiStatus,
}) => {
  const { JobLimit: jobLimit } = userConfig;
  const {
    OrgActivatedJobsCount: orgActivatedJobsCount,
    OrgOpenedJobsCount: orgOpenedJobsCount,
    IsJobActivationChargeEnabledOnJobOpen: isJobActivationChargeEnabledOnJobOpen,
  } = userConfig;
  React.useEffect(() => {
    if (visible) {
      fetchOrgActivatedJobsCount();
      fetchOrgOpenedJobsCount();
    }
  }, [visible]);
  const isApplicationSettingsEnabled = featureToggleList.ApplicationSettings.IsEnabled;
  const isPaidJobServiceEnabled = featureToggleList.PaidJobService.IsEnabled;
  const isNotificationSettingsEnabled = featureToggleList.SourcingNotificationEmails.IsEnabled;
  const isUserBudgetCappingEnabled = featureToggleList.UserBudgetCapping.IsEnabled;
  const shouldShowCalendarAsHome = isCalendarHomePage();
  const config = getConfiguration([firstName, lastName].join(' '));
  const fullName = `${firstName ?? ''} ${lastName ?? ''}`;

  const handleMenuItemClick = (path, toggleClientDrawer = false) => {
    history.push(path);
    hidePopover();
    if (toggleClientDrawer) {
      toggleClientAddDrawer();
    }
  };

  const orgActivatedOrOpenedJobsCount = isJobActivationChargeEnabledOnJobOpen
    ? orgOpenedJobsCount
    : orgActivatedJobsCount;

  const jobActivationTooltip = 'No. of Job Activations left';

  return (
    <div className="user-settings-content">
      <div className="user-settings-info">
        <div className="user-settings-avatar">
          <Avatar size={50} style={{ color: '#ffffff', backgroundColor: config.color }}>
            {config.text}
          </Avatar>
        </div>
        <div className="user-settings-primary-info">
          <div className="user-settings-name">
            <Tooltip placement="top" title={fullName}>
              {fullName}
            </Tooltip>
          </div>
          <div className="user-settings-email">{email}</div>
          <div className="user-settings-edit-profile">
            <LinkButton
              buttonName={<FormattedMessage {...messages.editProfile} />}
              onClickButton={() => handleMenuItemClick('/settings/profile')}
            />
          </div>
        </div>
      </div>
      <BudgetIndicator
        currentBudgetInfo={currentUserBudget}
        postBudgetCappingRequest={postBudgetCappingRequest}
        isUserBudgetCappingEnabled={isUserBudgetCappingEnabled}
        postCreditsRequestApiStatus={postCreditsRequestApiStatus}
      />
      <div className="user-settings-options">
        {isApplicationSettingsEnabled ? (
          <div className="user-settings-option">
            <span role="presentation" onClick={() => handleMenuItemClick('/settings/app')}>
              <FormattedMessage {...messages.applicationSettings} />
            </span>
          </div>
        ) : null}
        {isPaidJobServiceEnabled ? (
          <div className="user-settings-option">
            <span role="presentation" onClick={() => handleMenuItemClick('/orders')}>
              <FormattedMessage {...messages.viewOrderHistory} />
            </span>
          </div>
        ) : null}
        {role !== 'Recruiter' ? (
          <div className="user-settings-option">
            <span role="presentation" onClick={() => handleMenuItemClick('/settings/admin')}>
              <FormattedMessage {...messages.adminSettings} />
            </span>
          </div>
        ) : null}
        {/* {role !== 'Recruiter' ? (
          <div className="user-settings-option">
            <span>
              <FormattedMessage {...messages.users} />
            </span>
            <span className="add-new">+ Add new</span>
          </div>
        ) : null} */}
        {role !== 'Recruiter' && !shouldShowCalendarAsHome ? (
          <div className="user-settings-option">
            <span role="presentation" onClick={() => handleMenuItemClick('/settings/clients')}>
              <FormattedMessage {...messages.clients} />
            </span>
            <div className="add-new">
              <LinkButton
                buttonName={intl.formatMessage({ ...messages.addClient })}
                onClickButton={() => handleMenuItemClick('/settings/clients', true)}
              />
            </div>
          </div>
        ) : null}
        {/* <div className="user-settings-option">
        <span>
          <FormattedMessage {...messages.reportingPortal} />
        </span>
      </div> */}
        {isNotificationSettingsEnabled ? (
          <div className="user-settings-option">
            <span role="presentation" onClick={() => handleMenuItemClick('/settings/notifications')}>
              <FormattedMessage {...messages.notificationSettings} />
            </span>
          </div>
        ) : null}
        <div className="user-settings-option logout-wrapper">
          <LogOutButton
            onSignOut={signOut}
            renderProp={(handleClick, logoutButtonText) => (
              <span className="logout" onClick={() => handleClick()} role="presentation">
                <Icon type="logout" className="logout-icon" />
                {logoutButtonText}
              </span>
            )}
          />
          {jobLimit !== undefined && orgActivatedOrOpenedJobsCount !== undefined && !isPaidJobServiceEnabled ? (
            <div className="job-activation-remaining-count-wrapper">
              <Tooltip title={jobActivationTooltip} placement="topRight">
                <JobCreditIcon />
                <span className="job-activation-remaining-count">{jobLimit - orgActivatedOrOpenedJobsCount}</span>
              </Tooltip>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(Form.create()(SettingsMenu));
export { SettingsMenu as SettingsMenuWithoutInjectIntl };
